import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import AgencyHierarchyView from './AgencyHierarchyView';
import { getAgenciesTree } from 'state/actions/actions';

function mapStateToProps({ agencyManagement }) {
  return {
    agenciesTree: agencyManagement.agenciesTree
  };
}

export default connect(mapStateToProps, { getAgenciesTree })(
  withLocalLoader(
    AgencyHierarchyView,
    true,
    'Agency Management',
    'Agency Management'
  )
);
